<template>
  <div class="payaffirm">
    <div class="payaffirm-head">
      <img src="@/assets/images/h5/icon22.png" @click="$router.go(-1)" alt="" />
      <p>
        {{ $t("paygame.payConfirm") }}
      </p>
    </div>
    <div class="payaffirm-content">
      <span>{{ orderList.product_name }}</span>
      <span>{{ orderList.marketing_desc_1 }}</span>
      <span>{{ orderList.marketing_desc_2 }}</span>
    </div>
    <div class="payaffirm-state">
      <div>
        <img src="@/assets/images/h5/icon21.png" alt="" /><span>{{
          $t("paygame.payTip1")
        }}</span>
      </div>
    </div>
    <div class="payaffirm-list">
      <div class="payaffirm-list-lable">
        <ul>
          <li>
            <span>{{ $t("paygame.paygameName") }}</span>
          </li>
          <li>
            <span>{{ $t("paygame.komoeAccount") }}</span>
          </li>
          <li>
            <span>{{ $t("paygame.gameRole") }}</span>
          </li>

          <li>
            <span>{{ $t("h5page.paygame.text8") }}</span>
          </li>
          <li>
            <span>{{ $t("h5page.paygame.text9") }}</span>
          </li>
          <li class="codenames">
            <span>{{ $t("paygame.captcha") }}</span>
          </li>
        </ul>
      </div>
      <div class="payaffirm-list-cont">
        <ul>
          <li>
            <span>{{ orderList.game_name }}</span>
          </li>
          <li>
            <span>{{ orderList.account }}</span>
          </li>
          <li>
            <span
              >{{ orderList.cp_role_name }}(ID:{{ orderList.cp_role_id }})</span
            >
          </li>

          <li>
            <span>{{ orderList.payment_desc }}</span>
          </li>
          <li>
            <span class="moneys">{{ orderList.moneyAmount }}</span
            ><span class="moneys1">{{ orderList.moneyName }}</span>
          </li>
          <li class="codes">
            <input-data
              ref="codes"
              v-model.trim="captcha_code"
              :placeholder="$t('paygame.insertCaptcha')"
              :stateTitle="$t('paygame.msg5')"
            >
              <div
                v-if="imgUrl"
                class="yanzm"
                :style="` background: url(${imgUrl}) no-repeat center /cover;`"
                @click="getCode"
              ></div>
            </input-data>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="payaffirm-btn"
      v-if="
        orderList.secondary_switch_status == 1 &&
          orderList.main_switch_status == 1
      "
      @click="createOrder"
    >
      <span>{{ $t("paygame.payNow") }}</span>
    </div>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import h5Nav from "@/component/h5nav/komoe";
import inputData from "./component/inputdata.vue";
export default {
  name: "pays_h5Payaffirm",
  components: {
    h5Nav,
    inputData,
  },
  data() {
    return {
      lineIndex: 1,
      codeImg: "",
      orderList: [],
      distribution_region: 5,
      imgUrl: "",
      captcha_token: "",
      captcha_code: "",
      payment_url: "",
      order_no: "",
      isProductSelect: true,
      auth_code: "",
    };
  },
  created() {
    // console.log(this.$route.query)
    if (!this.$route.query.dataInfo) {
      this.$router.push({
        path: "/h5",
      });
      return;
    }
    this.orderList = JSON.parse(this.$route.query.dataInfo);
  },
  mounted() {
    this.getCode();
  },
  methods: {
    errMsg2Key(val) {
      this.$notify({
        color: "#fff",
        background: "#50bbe5",
        message: this.$t(`paygame.${val}`),
      });
    },
    // 游戏充值下单 确认弹窗按钮点击
    createOrder() {
      if (!this.captcha_code) {
        this.$refs.codes.setinputstate();
        // this.errMsg2Key("msg5");
        return;
      }
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      // console.log( this.orderList)
      // return
      this.$apis.paygame
        .addKomoePayOrder(
          this.orderList.game_base_id,
          this.orderList.game_id,
          this.orderList.cp_server_id,
          this.orderList.cp_role_id,
          this.orderList.product_id,
          this.orderList.product_name,
          this.orderList.marketing_desc_1,
          this.orderList.marketing_desc_2,
          // this.merchandiseInfo.product_price,
          this.orderList.moneyAmount,
          this.orderList.currency,
          this.orderList.pay_mode,
          this.orderList.payment_type,
          this.captcha_token,
          this.captcha_code,
          3,
          true
        )
        .then(({ data }) => {
          this.$toast.clear();
          if (data.code == 0) {
            this.auth_code = data.data.auth_code;
            this.order_no = data.data.order_no;
            this.$router.push({
              path: "/pays_h5/paycomplete",
              query: {
                payment_url:
                  this.orderList.payment_url + "?AuthCode=" + this.auth_code,
                payment_type: this.orderList.payment_type,
                moneyAmount: this.orderList.moneyAmount,
                moneyName: this.orderList.moneyName,
                order_no: this.order_no,
                payment_desc: this.orderList.payment_desc,
                marketing_desc_1: this.orderList.marketing_desc_1,
                marketing_desc_2: this.orderList.marketing_desc_2,
              },
            });
            if (this.orderList.payment_url && this.auth_code) {
              window.open(
                this.orderList.payment_url + "?AuthCode=" + this.auth_code
              );
            }
          } else {
            if (data.code === -101) {
              this.$router.push({
                name: "/login_h5",
              });
            } else if (data.code == -105) {
              if (this.isProductSelect) {
                this.errMsg2Key("err1");
              } else {
                this.errMsg2Key("msg9");
              }
            } else if (data.code == 1001) {
              this.errMsg2Key("err2");
            } else if (data.code == 2000) {
              this.errMsg2Key("err3");
            } else if (data.code == 2001) {
              this.errMsg2Key("err4");
            } else if (data.code == 2002) {
              this.errMsg2Key("err5");
            } else if (data.code == 2003) {
              this.errMsg2Key("err6");
            } else if (data.code == 2004) {
              this.errMsg2Key("err7");
            } else if (data.code == 2005) {
              this.errMsg2Key("err8");
            } else if (data.code == 2006) {
              this.errMsg2Key("err9");
            } else if (data.code == 2007) {
              this.errMsg2Key("err10");
            } else if (data.code == 2008) {
              this.errMsg2Key("err11");
            } else if (data.code == 2009) {
              this.errMsg2Key("err12");
            } else if (data.code == 2011) {
              this.errMsg2Key("err13");
            } else if (data.code == 2012) {
              this.errMsg2Key("msg10");
            } else {
              // 服务器内部错误
              this.errMsg2Key("err2");
            }
            // if (tag === "common") {
            //   this.errMsgInfo = this.errMsgSure;
            //   this.showCommonModal = true;
            // }
            this.getCode();
          }
        })
        .catch(() => {
          this.$toast.clear();
          this.errMsg2Key("err2");
        });
    },
    // 獲取圖形驗證碼
    getCode() {
      this.imgUrl = "";
      this.$apis.paygame.getKomoeCaptcha().then(({ data }) => {
        if (data.code == 0) {
          this.imgUrl = data.data.url;
          this.captcha_token = data.data.token;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.payaffirm {
  width: 100%;
  height: auto;
  background: white;
  margin-top: 0.48rem;
  &-head {
    width: 92%;
    height: 0.5rem;
    margin: auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: absolute;
      left: 0;
      top: 50%;
      width: 0.12rem;
      height: 0.2rem;
      transform: translateY(-50%);
    }
    p {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 0.22rem;
      font-weight: bold;
      color: #444444;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0.8rem;
        height: 0.04rem;
        background: #50bbe5;
        border-radius: 0.02rem;
      }
    }
  }
  &-content {
    width: 92%;
    min-height: 1.57rem;
    margin: auto;
    margin-top: 0.2rem;
    background: #fbfbfb;
    border-radius: 0.11rem;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: flex-end;
    span {
      font-size: 0.1rem;
      font-weight: 400;
      color: #999999;
      margin-bottom: 0.15rem;
      &:nth-of-type(1) {
        margin-bottom: 0.17rem;
        font-size: 0.13rem;
        font-weight: bold;
        color: #444444;
      }
    }
  }
  &-state {
    width: 92%;
    height: auto;
    margin: auto;
    margin-top: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff4cd;
    border-radius: 0.15rem;
    div {
      width: 90%;
      height: 0.3rem;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.14rem;
        height: 0.14rem;
        margin-right: 0.05rem;
      }
      span {
        font-size: 0.09rem;
        font-weight: 400;
        color: #ffb13b;
      }
    }
  }
  &-list {
    width: 92%;
    height: auto;
    margin: auto;
    margin-top: 0.12rem;
    display: flex;
    justify-content: space-between;
    &-lable {
      width: auto;
      height: auto;
      ul {
        width: auto;
        height: auto;
        li {
          width: auto;
          height: 0.35rem;
          display: flex;
          align-items: center;
          &.codenames {
            margin-top: 0.12rem;
          }
          span {
            font-size: 0.11rem;
            font-weight: 400;
            color: #bdbdbd;
          }
        }
      }
    }
    &-cont {
      flex: 1;
      height: auto;
      display: flex;
      justify-content: flex-end;
      ul {
        width: 95%;
        height: auto;
        li {
          width: auto;
          height: 0.35rem;
          display: flex;
          align-items: center;
          span {
            font-size: 0.11rem;
            font-weight: 400;
            color: #444444;
            &.moneys {
              font-size: 0.15rem;
              font-weight: 800;
              color: #54c5f8;
            }
            &.moneys1 {
              margin-left: 0.05rem;
              font-size: 0.11rem;
              font-weight: 400;
              color: #bdbdbd;
            }
          }
          &.codes {
            margin-top: 0.12rem;
            margin-bottom: 0.5rem;
            .yanzm {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 1.12rem;
              height: 0.3rem;
              margin-right: 0.05rem;
              background: rgba(240, 155, 212, 0);
              border: 1px solid #cccccc;
              border-radius: 0.14rem;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: border-box;
              background: white;
            }
          }
        }
      }
    }
  }
  &-btn {
    width: 1.82rem;
    height: 0.35rem;
    margin: auto;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    background: #54c5f8;
    border-radius: 0.17rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 0.12rem;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
</style>
